const styles = theme => ({
  titleWrapper: {
    display: 'flex',
    marginBottom: `${theme.spacing.unit * 2.125}px !important`,
    position: 'relative'
  },
  title: {
    flex: 1,
    fontWeight: 'bold !important'
  },
  resetLinkButton: {
    position: 'absolute',
    right: 0,
    top: -6
  },
  resetLink: {
    textTransform: 'capitalize',
    color: `${theme.palette.primary.main} !important`
  },
  modalFooter: {
    marginTop: `${theme.spacing.unit * 5}px !important`
  },
  checkboxLabel: {
    margin: 0,
    position: 'relative',
    top: 6
  },
  checkbox: {
    marginTop: [theme.spacing.unit * 1.5, '!important'],
    '&:first-child': {
      marginTop: [0, '!important']
    }
  },
  checkboxesContainer: {
    padding: [[0, theme.spacing.unit], '!important']
  },
  placeholderIcon: {
    color: 'rgba(12,31,44,0.54)'
  },
  placeholderDisplay: {
    display: 'none'
  }
});

export default styles;
